module.exports = __webpack_public_path__ + "static/media/img-3.f9b429c1.jpg";